import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistExternalSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  miscTrashArea: environmentalChecklistItem,
  miscRoof: environmentalChecklistItemWithTicket,
  miscGutter: environmentalChecklistItemWithTicket,
  miscExteriorYard: environmentalChecklistItemWithTicket,
  miscExtFurniture: environmentalChecklistItemWithTicket,
  miscShrubbery: environmentalChecklistItemWithTicket,
  miscExteriorDoor: environmentalChecklistItemWithTicket,
  miscHandrails: environmentalChecklistItemWithTicket,
  miscSmoking: environmentalChecklistItem,
  miscDryerVent: environmentalChecklistItemWithTicket,
  miscDoorChime: environmentalChecklistItemWithTicket,
});
